module.exports = __webpack_public_path__ + "static/media/domain4.cd122545.png";